import React, { useState, useEffect } from "react";
import { Divider, Grid, Button, Stack, TextField, Backdrop } from "@mui/material";
import { IconButton, InputAdornment, CircularProgress } from "@mui/material";
import Search from "@mui/icons-material/Search";
import {ThemeProvider, createTheme} from "@mui/material";
import {Tab, Box} from "@mui/material";
import {TabPanel, TabContext, TabList} from "@mui/lab";
import { DatePicker } from "@mui/x-date-pickers";
import { useSelector } from "react-redux";
import "./Reports.css";
import dayjs from 'dayjs';
import { getAchReportList } from "../common/constants/globalconstants";
import DataTable from "react-data-table-component";
import { reportColumns, customReportColumns, ReportExcelColumns } from "./ReportColumns";
import { CustomExcelExport } from "../common/CustomExcelExport";
import ErrorModal from "../common/ErrorModal";
import axiosInstance from "../common/AxiosInterceptor";
import {carefacilitydetails, getDefaultCareFacility} from "../common/Utils";

const customStyle = {
	table:{
		style: {
			border:'1px solid #DEDEDE', 
			borderRadius:'5px'
		}
	},
	header: {
		style:{
			color: '#193062'
		}
	},
	headRow: {
		style: {
			border:"none",
			backgroundColor: '#CDD4DC',
			fontWeight: 'bold',
            color:'#002d82',
            fontSize:'14px',
            whiteSpace:'unset'
		}
	},
	rows: {
		stripedStyle: {
			backgroundColor: '#F2F3F5'
		}
	}
}
const theme = createTheme();

export default function Reports(){
    const [value, setValue] = useState('custom');
    const [fromDateErr, setFromDateErr] =useState(false);
    const [toDateErr, setToDateErr] =useState(false);
    const [compareDateErr, setCompareDateErr] =useState(false);
    const [fromDate, setFromDate] = useState(dayjs(new Date()));
    const [toDate, setToDate] = useState(dayjs(new Date()));
    const [formattedFromDate, setFormattedFromDate] = useState(dayjs(new Date()));
    const [formattedToDate, setFormattedToDate] = useState(dayjs(new Date()));
    const [accountNum, setAccountNum] = useState();
    const [loading, setLoading] = useState(false);
    const [midMonthData, setMidMonthData] = useState([]);
    const [monthEndData, setMonthEndData] = useState([]);
    const [customData, setCustomData] = useState([]);
    const [downloadMidMonthData, setDownloadMidMonthData] = useState([]);
    const [downloadMonthEndData, setDownloadMonthEndData] = useState([]);
    const [downloadCustomData, setDownloadCustomData] = useState([]);
    const [midMonthDataInitial, setMidMonthDataInitial] = useState([]);
    const [monthEndDataInitial, setMonthEndDataInitial] = useState([]);
    const [customDataInitial, setCustomDataInitial] = useState([]);
    const [fileNameFrmDt, setFileNameFrmDt] = useState("");
    const [fileNameToDt, setFileNameToDt] = useState("");
    const [searching, setSearching] = useState(false);
    const [errormodalopen, seterrormodalOpen]= useState(false);
    const [resetPagination, setRstPagination]= useState(false);
    const [searchBtnClicked, setSearchBtnClicked] = useState(false);

    const [errors, setErrors] = useState({
      fromDate: "",
      err_fromDate: false,
      toDate: "",
      err_toDate: false,
    });
    const carefacilitydetails = useSelector((state) => state.carefacilitydetails);
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]


    useEffect(()=>{
      setCarefacilitydefaultVals();
    },[carefacilitydetails])   
  
    const setCarefacilitydefaultVals = () =>{
      setAccountNum(carefacilitydetails.accountNumber);
    }

    useEffect(()=>{
      if(carefacilitydetails.accountNumber != "" && carefacilitydetails.accountNumber != undefined){
        loadReportData("initial");
      }
    },[carefacilitydetails]);

    const handleChange = (event, newValue) =>{
        setValue(newValue);
        if(newValue === "midMonth"){
          setMidMonthData(midMonthData)
        }
        else if(newValue === "midMonth"){
          setMonthEndData(monthEndData)
        }
        else {
          setCustomData(customData)
        }
    }

  const getDatesforInputSearch= async(fromDate, toDate) =>{
    let formattedFromDate;
    let formattedToDate;
    if(fromDate && toDate){
      const fromYear = dayjs(fromDate).year();
      const fromMonth = dayjs(fromDate).month()+1;
       formattedFromDate = `${('0'+ fromMonth).slice(-2)}-21-${fromYear.toString()}`;

      const nextMonthDate = dayjs(toDate).add(1, 'month');
      const nextMonth = nextMonthDate.month()+1;
      const nextYear = nextMonthDate.year();
      formattedToDate = `${('0' + nextMonth).slice(-2)}-04-${nextYear.toString()}`;

      setFileNameFrmDt(months[fromMonth-1]+fromYear);
      setFileNameToDt(months[nextMonth-2]+nextYear);
      //setFormattedFromDate(`${('0'+ fromMonth).slice(-2)}/21/${fromYear.toString()}`);
      //setFormattedToDate(`${('0' + nextMonth).slice(-2)}/04/${nextYear.toString()}`);
      setFormattedFromDate(`${months[fromMonth-1]} ${fromYear}`);
      setFormattedToDate(`${months[nextMonth-2]} ${nextYear}`);

      getReportData(formattedFromDate, formattedToDate);
    }
  }

  const getDatesforInitialLoad = ()=>{
      const today = new Date();      
      let formattedFromDate;
      let formattedToDate;
      let fromMonth;
      const fromYear = dayjs(today).year();
      fromMonth = dayjs(today).month()+1;
      const date = dayjs(today).date();
      formattedFromDate = `${('0'+ fromMonth).slice(-2)}-21-${fromYear.toString()}`;

      const nextMonthDateCur = dayjs(today);
      const nextMonthDate = nextMonthDateCur.add(1, 'month');
      //const nextMonth = nextMonthDate.month()+2;
      const nextMonth = nextMonthDate.month()+1;
      const nextYear = nextMonthDate.year();      
      
      formattedToDate = `${('0' + nextMonth).slice(-2)}-04-${nextYear.toString()}`;
      setFileNameFrmDt(months[fromMonth-1]+fromYear);
      setFileNameToDt(months[nextMonth-2]+nextYear);
      //setFormattedFromDate(`${('0'+ fromMonth).slice(-2)}/21/${fromYear.toString()}`);
      //setFormattedToDate(`${('0' + nextMonth).slice(-2)}/04/${nextYear.toString()}`);
      setFormattedFromDate(`${months[fromMonth-1]} ${fromYear}`);
      //setFormattedToDate(`${months[nextMonth-2]} ${nextYear}`);
      setFormattedToDate(`${months[nextMonthDateCur.month()+1-1]} ${nextMonthDateCur.year()}`);
      
      getReportData(formattedFromDate, formattedToDate);
     }

  const getReportData = async(formattedFromDate, formattedToDate) =>{
    try{
    const request = {
      "accountNo": carefacilitydetails.accountNumber? carefacilitydetails.accountNumber : "", //"811690501",////"0812330401",
      "fromDate": formattedFromDate,
      "toDate": formattedToDate
    }
    setLoading(true);
    const response = await axiosInstance.post(`${getAchReportList}`, request);
    if(response && response.data.isSuccess){
        SeggregateData(response.data.result)
        seterrormodalOpen(false);
    }
    else if(response && !response.data.isSuccess){
        seterrormodalOpen(true);
    }
    setLoading(false);
  }
  catch (error) {
    console.log(error);
    seterrormodalOpen(true);
    setLoading(false);
  }
  }

  const SeggregateData = (data) =>{
    const midMonthData = data && data.filter(row => row.reportType && row.reportType.split("-")[1] === "MidMonth" );
    const monthEndData = data && data.filter(row => row.reportType && row.reportType.split("-")[1] === "MonthEnd" );
    const customData = data && data.filter(row => (row.reportType && row.reportType.split("-")[1] === "MidMonth") || (row.reportType && row.reportType.split("-")[1] === "MonthEnd"));
      setMidMonthData(midMonthData);
      setMonthEndData(monthEndData);
      setCustomData(customData);

      setMidMonthDataInitial(midMonthData);
      setMonthEndDataInitial(monthEndData);
      setCustomDataInitial(customData);

      setDownloadMidMonthData(midMonthData);
      setDownloadMonthEndData(monthEndData);
      setDownloadCustomData(customData);
  }

  const validateFields = () =>{
    let error = false;
     if (fromDate === "" || fromDate === undefined) {
      setFromDateErr(true);
      error = true;
      return error;
    }else{
      setFromDateErr(false);
      error = false;
    }

    if (toDate === "" || toDate === undefined) {
      setToDateErr(true);
      error = true;
    }
    else{
      setToDateErr(false);
      error = false;
    }   
    
    if(fromDate > toDate){
      setCompareDateErr(true);
      error = true;
    }
    else{
      setCompareDateErr(false);
      error = false;
    }
   
    return error;
  }

  const handleSearchClick = () =>{
    setSearchBtnClicked(true);
    setRstPagination(!resetPagination);
    setSearching(false);
    let error = validateFields();
    if(!error) {
      loadReportData("search");
    }
  }

  const loadReportData = (operation) =>{
    if(operation === "search"){
      getDatesforInputSearch(fromDate, toDate);
    }else if(operation === "initial"){
      getDatesforInitialLoad();
    }
  }

 const handleChangeSearchText = (e, initialData, data, type) =>{
    setRstPagination(!resetPagination);
    setSearching(true);
    let searchValue = false ;
		let firstName = false ;
		let lastName = false;
		let mrId = false ;
		let ssn = false;
    let reportType = false;
		let paymentAmt = false ;
		let allowance = false;
    let netAmt = false;
    let paymentCode = false;
    let paymentDesc = false;
        
    if(e.target.value === ""){
      if(type === "midMonth"){
        setMidMonthData(data)
      }
      else if(type === "monthEnd"){
        setMonthEndData(data)
      }
      else if( type === "custom"){
        setCustomData(data);
      }
    }

		const newdata = initialData && initialData.filter( row => {
			firstName = row.firstName && row.firstName.toLowerCase().includes(e.target.value.toString().toLowerCase());
			lastName = row.lastName && row.lastName.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      mrId = row.mrId && row.mrId.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      ssn = row.ssn && row.ssn.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      reportType = row.reportType && row.reportType.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      paymentAmt = row.paymentAmount && row.paymentAmount.toString().includes(e.target.value.toString());
      paymentCode = row.paymentCode && row.paymentCode.toString().includes(e.target.value.toString());
			allowance = row.allowance && row.allowance.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
      netAmt = row.netAmount && row.netAmount.toString().includes(e.target.value.toString());
			paymentCode = row.paymentCode && row.paymentCode.toLowerCase().includes(e.target.value.toString().toLowerCase());
      paymentDesc = row.paymentDesc && row.paymentDesc.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
			if(firstName){
				searchValue = firstName
			}
			else if(lastName){
				searchValue = lastName
			}
      else if(mrId){
				searchValue = mrId
			}
			else if(ssn){
				searchValue = ssn
			}
      else if(reportType){
				searchValue = reportType
			}
      else if(paymentAmt){
				searchValue = paymentAmt
			}
      else if(netAmt){
				searchValue = netAmt
			}
			else if(paymentCode){
				searchValue = paymentCode
			}
			else if(paymentDesc){
				searchValue = paymentDesc
			}
			else{
				searchValue = allowance
			}

			return searchValue;
      })
        if(type === "midMonth"){
          setMidMonthData(newdata)
        }
        else if(type === "monthEnd"){
          setMonthEndData(newdata)
        }
        else if( type === "custom"){
          setCustomData(newdata);
        }
  }

 const getDateRange =(date, dateField) =>{
  const newDate = new Date(date);
  const monthName = newDate.toLocaleString('default', {month: 'long'});
  const year = newDate.getFullYear();

  let formattedDate = `${monthName} ${year}`;

   //Handle December
   if (monthName === "January" && dateField =="to_Date" && searchBtnClicked) {
    if(new Date(formattedFromDate).getFullYear() !== new Date(formattedToDate).getFullYear()){
     newDate.setMonth(newDate.getMonth() - 1); // Subtract one month
     formattedDate = `${newDate.toLocaleString('default', { month: 'long' })} ${newDate.getFullYear()}`;
    }
   }
  return formattedDate;
 }

  const conditionalRowStyles = [
  {
      when: row =>row.lastName && row.lastName.toUpperCase().trim() === "ACCOUNT TOTAL",
      style: {
        backgroundColor: "#ADD8E6",
        color: "black",
        '&:hover':{
          backgroundColor: "#ADD8E6",
          color: "black",
        }
      }
  },
  {
    when: row =>((row.paymentDesc && row.paymentDesc.toUpperCase().trim() === "MULTIPLE PAYMENTS")),
    style: {
      backgroundColor: "#fffdaf",
      color: "black",
      '&:hover':{
        backgroundColor: "#fffdaf",
        color: "black",
      }
    }
}, 
{
  when: row =>(row.firstName===null && row.lastName===null),
  style: {
    backgroundColor: "#fffdaf",
    color: "black",
    '&:hover':{
      backgroundColor: "#fffdaf",
      color: "black",
    }
  }
}, 
]

    return(
        <Box
        sx={{
          position: "relative",
          alignContent:"center",
          justifyContent: "center",
          left: "2%",
          flexDirection: "column",
          width: "95%",
          marginTop: "20px",
          marginBottom: "20px",
          alignItems: "center",
          p: "0% 1%",
          backgroundColor: "#fcfcfc",
          //border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
            <h2 className="header">Care Facility Reports</h2>
            
          <div>
           <Grid 
            item
            xs={7.7}
            sx={{
              p: "5px 16px",
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              backgroundColor: "white",
              marginTop: "5px",
              marginBottom: "5px"
            }}>
           <Grid xs = {12}>
           <p style={{fontSize:"13px", fontWeight: 10, color: "grey", marginTop: "12px", marginBottom:"12px", fontFamily:'sans-serif'}}><strong>Note: </strong> Mid Month Report is generated on 21st of every month & Month End report is generated on 4th of the successive month</p>
           <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "70%", height: "60px", m: "3px 0" }}
            >
             
                <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                <p className="input-from-label">
                  From Date
                </p>
             <DatePicker
                  className="report-from-datePicker"
                  style={{height: "15px !important"}}
                  views={['month','year']}
                  sx={{ ml: "0px", width: "59%", "& .MuiInputBase-input":{ height: "10px !important"} }}
                  onChange={(newValue)=> 
                    setFromDate(newValue)
                  }
                  value={fromDate}
                  placeholder="MM YYYY"
                  helperText={fromDate==="" || fromDate === undefined? "From Date can't be blank" : ""}
                  error={fromDate===""? true : false}
                  renderInput={(params)=>(
                  <TextField {...params}
                  helperText={errors.fromDate}
                  error={errors.err_fromDate}
                  />)}
                  size="small"
                ></DatePicker> 
                </Box>
                <br></br>
                                
               
                <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                <p className="input-to-label">
                  To Date
                </p>
                <DatePicker
                  className="report-to-datePicker"
                  style={{height: "15px !important"}}
                  views={['month','year']}
                  sx={{ ml: "0px", width: "59%", "& .MuiInputBase-input":{ height: "10px !important"} }}
                  onChange={(newValue)=> {
                    setToDate(newValue);
                    setErrors((prev)=> ({...prev, toDate:""}));
                  }
                  }
                  value={toDate}
                  placeholder="MM YYYY"
                  renderInput={(params)=><TextField {...params}
                  helperText={errors.toDate}
                  error={errors.err_toDate}/>}
                  size="small"
                ></DatePicker>
               
                </Box>
                <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                <Button
                  variant="contained"
                  className="reports-button"
                  onClick={handleSearchClick}
                >
                  Search
                </Button>
                </Box>
                </Stack>
            <div style={{marginTop: "40px", width:"95%"}}>              
              
            <Box
            sx={{
              border:"1px solid #002d82",
              padding:"5px",
              position:"relative",
              display:"inline-block",
              barderRadius:"5px",
              width: "100%",
              height:"50px"
            }}>
               <Box
            display="flex"
                direction="row"
                alignItems="center"
                justifyContent="center"
                alignContent="center"
                sx={{ width:"100%", height: "50px", m: "3px 0", marginTop:"5px"   }} 
            >
		        <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                alignContent: "center",
				        width: "33%",
				        height: "30px",
                fontSize: "15px"
              }}
            > 
             <p style={{width: "120px", color: "black",fontWeight: "600"}}>Printed On:</p>
             <p style={{width: "250px"}}>{dayjs(new Date()).format('MM/DD/YYYY hh:mm:ss')}</p>
           </Box>
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                alignContent: "center",
				        width: "35%",
				        height: "30px",
                fontSize: "15px"
              }}
            > 
              <p style={{width: "120px", color: "black",fontWeight: "600"}}>Nursing Home:</p>
              <p style={{width: "270px"}}>{carefacilitydetails && carefacilitydetails.careFacilityName}</p>
           </Box> 
            <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                alignContent: "center",
				        width: "30%",
				        height: "30px",
                fontSize: "15px"

              }}
            > 
            <p style={{width: "120px", color: "black",fontWeight: "600"}}>Date Range:</p>
            {/* <p style={{width: "250px"}}>{formattedFromDate +" To "+ formattedToDate}</p> */}
            <p style={{width: "250px"}}>{getDateRange(formattedFromDate, "from_Date") +" - "+ getDateRange(formattedToDate, "to_Date")}</p>
            </Box> 
            </Box> 
                
            <Box
            component="span"
            sx={{ 
              position: "absolute",
              top: "-12px",
              left:"15px",
              //transform:"translateX(-50%)",
              backgroundColor: "white",
              padding: "0 10px",
              fontSize:"14px",
              whiteSpace:"nowrap"
              }}
                >
                 Report Criteria:   
                      
            </Box>
            </Box>
            </div>
              </Grid> 
              <br></br>
              <Grid xs={12}>
                <Grid xs={6}>
                 {fromDateErr? <p id="note">From Date is mandatory ..!</p>: "" }
                 {compareDateErr && <p id="note">From Date should be less than To Date</p>}
                 {toDateErr && <p id="note">To Date is mandatory ..!</p>}
              </Grid>
              
              </Grid>

                <Grid xs={12}>
                <div style={{marginTop: "30px"}}>  
                <Box display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                 // width: "45%",
                }}> 
                <ThemeProvider theme={theme}>
                <Box sx={{width: "100%"}}>
                <TabContext value={value} //className= {classes.container}
                >
                <Box sx={{borderBottom: "1"}}>
                  <TabList
                    onChange={handleChange}
                    //className={classes.roundedTabs}
                    >
                      <Tab  
                        sx={{
                          textTransform: "none",
                          fontWeight: 12,
                          fontFamily: 'sans-serif',
                          fontSize: theme.typography.pxToRem(15),
                          color: "#000000",
                          borderBottom: "2px solid grey",
                          '&.MuiTabs-indicator':{
                            position: "absolute",
                            height: "2px",
                            bottom: "0 !important",
                            width: "100%",
                            transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                            backgroundColor: "#ffffff !important",
                          },
                           '&.Mui-selected':{
                            border : "2px solid grey" ,
                            borderTopLeftRadius: "15px",
                            borderTopRightRadius: "15px",
                            borderBottom: "none"  ,
                            borderBottomLeftRadius: "0"  ,
                            borderBottomRightRadius: "0"  ,
                            borderColor:" #1976d2 !important",
                         
                          '&:after':{
                            content:'""',
                            display: 'block',
                            borderBottom: 'none',
                          },
                        }
                        }} variant="fullwidth" value="midMonth" label="Mid Month"></Tab>
                        <Tab  
                        sx={{
                          textTransform: "none",
                          fontWeight: 12,
                          fontFamily: 'sans-serif',
                          fontSize: theme.typography.pxToRem(15),
                          color: "#000000",
                          borderBottom: "2px solid grey",
                          '&.MuiTabs-indicator':{
                            position: "absolute",
                            height: "2px",
                            bottom: "0 !important",
                            width: "100%",
                            transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                            backgroundColor: "#ffffff !important",
                          },
                          '&.Mui-selected':{
                            border : "2px solid grey" ,
                            borderTopLeftRadius: "15px",
                            borderTopRightRadius: "15px",
                            borderBottom: "none"  ,
                            borderBottomLeftRadius: "0"  ,
                            borderBottomRightRadius: "0"  ,
                            borderColor:" #1976d2 !important",
                          '&:after':{
                            content:'""',
                            display: 'block',
                            borderBottom: 'none',
                          },
                        }
                        }} variant="fullwidth" value="monthEnd" label="Month End"></Tab>
                        <Tab 
                        sx={{
                            textTransform: "none",
                            fontWeight: 12,
                            fontFamily: 'sans-serif',
                            fontSize: theme.typography.pxToRem(15),
                            color: "#000000",
                            borderBottom: "2px solid grey",
                            '&.MuiTabs-indicator':{
                              position: "absolute",
                              height: "2px",
                              bottom: "0 !important",
                              width: "100%",
                              transition: "all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                              backgroundColor: "#ffffff !important",
                            },
                            '&.Mui-selected':{
                              border : "2px solid grey" ,
                              borderTopLeftRadius: "15px",
                              borderTopRightRadius: "15px",
                              borderBottom: "none"  ,
                              borderBottomLeftRadius: "0"  ,
                              borderBottomRightRadius: "0"  ,
                              borderColor:" #1976d2 !important",
                            '&:after':{
                              content:'""',
                              display: 'block',
                              borderBottom: 'none',
                            },
                          }
                          }} variant="fullwidth" value="custom" label="Consolidated"></Tab>

                    </TabList>
                </Box>  
                {loading && (
                  <>
                <Backdrop
                  sx={{
                    color: "white",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={true}
                >
                  <CircularProgress sx={{ color: "white" }} />
                  <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading... </span>
                </Backdrop>
                </>
                )}

                  <TabPanel value="midMonth">                  
                  <Box>
                 {/* <div> 
                    {(midMonthData && midMonthData.length> 0) || searching?
                    <Box>
                    <TextField type="text" variant="outlined" 
                    sx={{borderRadius:'5px', height:"10px !important", marginBottom:"40px !important"}} 
                    placeholder="Search"
                        onChange={(e)=>handleChangeSearchText(e, midMonthDataInitial, midMonthData, "midMonth")}
                        className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx:{ borderRadius:'25px', paddingLeft: '5px', height: "50px"}
                        }} 
                    />
                    </Box>
                    :""}
                 </div> */}
          <Box sx={{display:"flex", flexDirection:"row", width:"100%", height:"55px", alignItems:"center", marginBottom:"5px"}}>
            <Box sx={{width:"50%", alignContent:"left", float:"left", justifyContent:"left",textAlign:"left"}}>
            <div style={{alignContent:"left", marginTop:"10px"}}>
            {midMonthData && midMonthData.length> 0? 
                      <CustomExcelExport
                      filename={`${fileNameFrmDt}-${fileNameToDt}-MidMonth.xlsx`}
                      data={midMonthData}
                      headers={ReportExcelColumns}
                      carefacility={carefacilitydetails}
                      type={"align-left"}
                      //carefacilityName="Test Nursing Home"
                      >
                      </CustomExcelExport>
                    : ""}
            </div>
            </Box>
            <Box sx={{width:"50%", alignContent:"right", float:"right", justifyContent:"right"}}>
              <div style={{alignContent:"right", textAlign:"right"}}>
              {(midMonthData && midMonthData.length> 0) || searching ?
                <TextField type="text" variant="outlined" 
                placeholder="Search"
                    onChange={(e)=>handleChangeSearchText(e, midMonthDataInitial, midMonthData, "midMonth")}
                    className='search-report-text'
                    InputProps={ {
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton>
                                    <Search />
                                </IconButton>
                            </InputAdornment>
                        ),
                        sx: { borderRadius: "5px", height: "40px", textAlign:"center" },
                    }} 
                />
              : null}
              </div>
            </Box>		 
          </Box>
                 <div>              
                  <DataTable
				          title=""
				          columns={reportColumns}
				          data={midMonthData}
                  pagination
                  striped
                  highlightOnHover
                  customStyles={customStyle}
                  paginationRowsPerPageOptions={[5,10,15,20]}
                  paginationResetDefaultPage={resetPagination}
                  paginationPerPage={5}
                  conditionalRowStyles={conditionalRowStyles}
                  paginationComponentOptions={{
                    rowsPerPageText:'Records per page',
                    rangeSeparatorText:'Out of'
                  }}			
			          />
                 
              </div>
                {/* <div>
                     {midMonthData && midMonthData.length> 0? 
                      <CustomExcelExport
                      filename={`${fileNameFrmDt}-${fileNameToDt}-MidMonth.xlsx`}
                      data={downloadMidMonthData}
                      headers={ReportExcelColumns}
                      carefacility={carefacilitydetails}
                      //carefacilityName="Test Nursing Home"
                      >
                      </CustomExcelExport>
                    : ""}
                </div> */}
                </Box>
                  </TabPanel>
                  <TabPanel value="monthEnd">
                  <Box>
                  {/* <div> 
                    {(monthEndData && monthEndData.length> 0) || searching?
                    <TextField type="text" variant="outlined"  
                    sx={{borderRadius:'5px', height:"10px !important", marginBottom:"40px !important"}} 
                        placeholder="Search"
                        onChange={(e)=>handleChangeSearchText(e, monthEndDataInitial, monthEndData, "monthEnd")}
                        className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx:{ borderRadius:'25px', paddingLeft: '5px', height: "50px" }
                        }} 
                    />: ""}
                 </div> */}

          <Box sx={{display:"flex", flexDirection:"row", width:"100%", height:"55px", alignItems:"center", marginBottom:"5px"}}>
            <Box sx={{width:"50%", alignContent:"left", float:"left", justifyContent:"left",textAlign:"left"}}>
            <div style={{alignContent:"left", marginTop:"10px"}}>
            {monthEndData && monthEndData.length> 0?
                      <CustomExcelExport
                      filename={`${fileNameFrmDt}-${fileNameToDt}-MonthEnd.xlsx`}
                      data={monthEndData}
                      headers={ReportExcelColumns}
                      carefacility={carefacilitydetails}
                      type={"align-left"}
                      >
                      </CustomExcelExport>
                    : ""}
            </div>
            </Box>
            <Box sx={{width:"50%", alignContent:"right", float:"right", justifyContent:"right"}}>
              <div style={{alignContent:"right", textAlign:"right"}}>
              {(monthEndData && monthEndData.length> 0) || searching?
                    <TextField type="text" variant="outlined"  
                    sx={{borderRadius:'5px', height:"10px !important", marginBottom:"40px !important"}} 
                        placeholder="Search"
                        onChange={(e)=>handleChangeSearchText(e, monthEndDataInitial, monthEndData, "monthEnd")}
                        className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx: { borderRadius: "5px", height: "40px", textAlign:"center" },
                        }} 
                    />: ""}
              </div>
            </Box>		 
          </Box>
                  <DataTable
				          title=""
				          columns={reportColumns}
				          data={monthEndData}
                  pagination
                  striped
                  highlightOnHover
                  customStyles={customStyle}
                  paginationRowsPerPageOptions={[5,10,15,20]}
                  paginationResetDefaultPage={resetPagination}
                  paginationPerPage={5}
                  conditionalRowStyles={conditionalRowStyles}
                  paginationComponentOptions={{
                    rowsPerPageText:'Records per page',
                    rangeSeparatorText:'Out of'
                  }}			
			          />
                 {/* <div>
                 {monthEndData && monthEndData.length> 0?
                      <CustomExcelExport
                      filename={`${fileNameFrmDt}-${fileNameToDt}-MonthEnd.xlsx`}
                      data={downloadMonthEndData}
                      headers={ReportExcelColumns}
                      carefacility={carefacilitydetails}
                      >
                      </CustomExcelExport>
                    : ""}
                </div> */}
                 </Box>
                  </TabPanel>
                  <TabPanel value="custom">
                  <Box>
                  {/* <div> 
                    {(customData && customData.length> 0) || searching?
                    <TextField type="text" variant="outlined" 
                        sx={{borderRadius:'5px', height:"10px !important", marginBottom:"40px !important"}}  
                        placeholder="Search"
                        onChange={(e)=>handleChangeSearchText(e, customDataInitial, customData, "custom")}
                        className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx:{ borderRadius:'25px', paddingLeft: '5px', height: "50px"}
                        }} 
                    />:""}
                 </div> */}
                 <Box sx={{display:"flex", flexDirection:"row", width:"100%", height:"55px", alignItems:"center", marginBottom:"5px"}}>
            <Box sx={{width:"50%", alignContent:"left", float:"left", justifyContent:"left",textAlign:"left"}}>
            <div style={{alignContent:"left", marginTop:"10px"}}>
            {customData && customData.length> 0? 
                      <CustomExcelExport
                      filename={`${fileNameFrmDt}-${fileNameToDt}-Consolidated.xlsx`}
                      data={customData}
                      headers={ReportExcelColumns}
                      carefacility={carefacilitydetails}
                      type={"align-left"}
                      >
                      </CustomExcelExport>
                    : ""}
            </div>
            </Box>
            <Box sx={{width:"50%", alignContent:"right", float:"right", justifyContent:"right"}}>
              <div style={{alignContent:"right", textAlign:"right"}}>
              {(customData && customData.length> 0) || searching?
                    <TextField type="text" variant="outlined" 
                        sx={{borderRadius:'5px', height:"10px !important", marginBottom:"40px !important"}}  
                        placeholder="Search"
                        onChange={(e)=>handleChangeSearchText(e, customDataInitial, customData, "custom")}
                        className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx: { borderRadius: "5px", height: "40px", textAlign:"center" },
                        }} 
                    />:""}
              </div>
            </Box>		 
          </Box>
                  <DataTable
				          title=""
				          columns={customReportColumns}
				          data={customData}
                  pagination
                  striped
                  highlightOnHover
                  customStyles={customStyle}
                  paginationRowsPerPageOptions={[5,10,15,20]}
                  paginationResetDefaultPage={resetPagination}
                  paginationPerPage={5}
                  conditionalRowStyles={conditionalRowStyles}
                  paginationComponentOptions={{
                    rowsPerPageText:'Records per page',
                    rangeSeparatorText:'Out of'
                  }}			
			          />
                 {/* <div>
                 {customData && customData.length> 0? 
                      <CustomExcelExport
                      filename={`${fileNameFrmDt}-${fileNameToDt}-Consolidated.xlsx`}
                      data={downloadCustomData}
                      headers={ReportExcelColumns}
                      carefacility={carefacilitydetails}
                      >
                      </CustomExcelExport>
                    : ""}
                </div> */}
                </Box>
                  </TabPanel>
                </TabContext>
                </Box>
                </ThemeProvider>
                </Box>
                </div>
              </Grid>
            </Grid>
           
            
          </div> 
            {errormodalopen && (
            <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
             )}
         {/* </div> */}
        </Box>
    )
}